import React from 'react';
import { Card } from './ui';
import { Star, XCircle } from 'lucide-react';
export function Testimonials() {
  return <section className="py-10 bg-brand-50 border-y border-lav-100" data-id="element-37" data-mp="3mvc2oy90k2g4">
      <div className="max-w-6xl mx-auto px-4" data-id="element-38" data-mp="38wvu11rlc1vc">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-39" data-mp="38w3xnoq66040">
          <div data-id="element-40" data-mp="3dtvrioadjwau">
            <p className="text-3xl font-bold text-ink mb-1" data-id="element-41" data-mp="3dxjltpnn8mqm">+1.200</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-42" data-mp="2z59dcpwhhal7">
              personas
            </p>
          </div>
          <div data-id="element-43" data-mp="33zdlvdledqoe">
            <p className="text-3xl font-bold text-ink mb-1" data-id="element-44" data-mp="2q6e6rcpj1yhd">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-45" data-mp="2q7z0x17xjfep">
              Tomos
            </p>
          </div>
          <div data-id="element-46" data-mp="2g7ycx1z48b46">
            <p className="text-3xl font-bold text-ink mb-1" data-id="element-47" data-mp="2g7ew5ol7bsrq">5</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-48" data-mp="2ga1biaec3cki">
              Bonos
            </p>
          </div>
          <div data-id="element-49" data-mp="2molg5s80c97g">
            <p className="text-3xl font-bold text-ink mb-1 flex items-center justify-center gap-1" data-id="element-50" data-mp="2mo27710c4v5k">
              4.9/5 <Star className="w-6 h-6 fill-brand-400 text-brand-400" data-id="element-51" data-mp="2hopbdqrhkdqu" />
            </p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-52" data-mp="2vprze921jy4e">
              calificación
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-53" data-mp="2qr8embz6osdm">
          <Card className="bg-white" data-id="element-54" data-mp="2302xzulf5w29">
            <div className="flex gap-1 mb-4" data-id="element-55" data-mp="23149u1a9eml1">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-56" data-mp="1z0u0qfr67g1y" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-57" data-mp="27zp7pu21gu6b">
              "Los ejercicios del nervio vago me ayudaron muchísimo en los
              momentos en que sentía el pecho apretado. Ahora sé qué hacer
              cuando aparece esa sensación."
            </p>
            <div className="flex items-center gap-3" data-id="element-58" data-mp="3fdj8xcwframd">
              <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 font-bold" data-id="element-59" data-mp="3fcq62n0ll59i">
                MG
              </div>
              <div data-id="element-60" data-mp="3p2t1suz3sxbj">
                <p className="font-bold text-ink" data-id="element-61" data-mp="3p4dvyjhiae8v">Mariana G.</p>
                <p className="text-xs text-slate-500" data-id="element-62" data-mp="3u25ys8jovkru">Córdoba</p>
              </div>
            </div>
          </Card>

          <Card className="bg-white" data-id="element-63" data-mp="2wfgolbeu21uw">
            <div className="flex gap-1 mb-4" data-id="element-64" data-mp="2wgi0fi3oasdo">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-65" data-mp="31ea1p2q7jquj" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-66" data-mp="3aeopq9uk3k1q">
              "Después de semanas de insomnio empecé la rutina nocturna del Tomo
              4. Termino el día con menos vueltas mentales y descanso mucho
              mejor."
            </p>
            <div className="flex items-center gap-3" data-id="element-67" data-mp="pqaf1xr7n80o">
              <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 font-bold" data-id="element-68" data-mp="2a56vgh04qmue">
                LP
              </div>
              <div data-id="element-69" data-mp="21dy7m0bpaqa6">
                <p className="font-bold text-ink" data-id="element-70" data-mp="21deserdfqfzu">Laura P.</p>
                <p className="text-xs text-slate-500" data-id="element-71" data-mp="21blgawk1z3kg">Rosario</p>
              </div>
            </div>
          </Card>

          <Card className="bg-white" data-id="element-72" data-mp="1rfigvygl5j17">
            <div className="flex gap-1 mb-4" data-id="element-73" data-mp="1rgjsq55fe9jz">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-74" data-mp="1mfm9dp8oj9gw" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-75" data-mp="1dg91v2448uyt">
              "Lo que más me sirvió fue el Plan de 30 Días. Tener un orden claro
              me saco la presión de hacer todo junto y hoy tengo una rutina que
              puedo sostener."
            </p>
            <div className="flex items-center gap-3" data-id="element-76" data-mp="37us6ba87x8jh">
              <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 font-bold" data-id="element-77" data-mp="24iuucuixf7wt">
                RM
              </div>
              <div data-id="element-78" data-mp="1viernna0c4t0">
                <p className="font-bold text-ink" data-id="element-79" data-mp="1vixxi5mdv2qo">Roberto M.</p>
                <p className="text-xs text-slate-500" data-id="element-80" data-mp="1vkistxgiuppl">Buenos Aires</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-81" data-mp="1lqs8n4rfh1fp">
      <div className="max-w-3xl mx-auto" data-id="element-82" data-mp="1qjlczrizi7r9">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-ink mb-5" data-id="element-83" data-mp="1qkmqe2nh36c5">
          TU CUERPO NO ESTÁ EXAGERANDO. ESTÁ ATRAPADO EN MODO SUPERVIVENCIA.
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-84" data-mp="1gujunuoyvea4">
          Podés intentar calmarte, distraerte o pensar en positivo, pero cuando
          el sistema nervioso permanece en alerta, el cuerpo sigue reaccionando
          como si existiera un peligro real.
        </p>

        <p className="text-lg font-bold text-center text-brand-600 mb-6" data-id="element-85" data-mp="o7to1vnuwxft">
          No es falta de fuerza. Muchas veces simplemente necesitás herramientas
          simples que puedas aplicar todos los días.
        </p>

        <Card className="bg-white border-brand-200 mb-6" data-id="element-86" data-mp="y6j73rrhonxn">
          <ul className="space-y-3" data-id="element-87" data-mp="t5vh99ezyd50">
            {['Nudo constante en la garganta.', 'Pecho apretado y sobresaltos.', 'Pensamientos acelerados.', 'Insomnio o sueño poco reparador.', 'Irritabilidad y tensión muscular.', 'Cansancio constante, sensación de no poder relajarte y ansiedad física sin una causa clara.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-88" data-mp="1bx4pzggy0xvj" data-mpi={i}>
                <XCircle className="w-6 h-6 text-brand-400 shrink-0 mt-0.5" data-id="element-89" data-mp="1pvmdbd2xs8cx" />
                <span className="text-slate-300 text-lg" data-id="element-90" data-mp="1lv2f066mmyp7">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-ink" data-id="element-91" data-mp="1sz1v76erou3k">
          ¿Y si esta fuera la última semana viviendo en alerta?
        </h3>
      </div>
    </section>;
}